import { useState, useEffect, useCallback } from 'react';
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
} from 'firebase/firestore';
import { db } from '../services/firebase';
import { hasGameStarted } from '../utils/formatters';

/**
 * Fetches today's upcoming (pickable) games from Firestore.
 * Only returns games with status "scheduled" that haven't started yet.
 */
export function useGames() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGames = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const gamesRef = collection(db, 'games');
      const q = query(
        gamesRef,
        where('status', '==', 'scheduled'),
        orderBy('startTime', 'asc')
      );

      const snapshot = await getDocs(q);
      const gamesList = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        // Double-check: exclude any game whose start time has already passed
        .filter((game) => !hasGameStarted(game.startTime));

      setGames(gamesList);
    } catch (err) {
      console.error('Error fetching games:', err);
      setError('Failed to load games. Please try again.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGames();
  }, [fetchGames]);

  return { games, loading, error, refetch: fetchGames };
}
